import {BaseModel} from "./base-model";

export class Configuration extends BaseModel {

  protected self = Configuration;

  authProvider: string;
  privacyPolicyUrl: string;
  signaller: { byn: string, jitsi: string };
  videoMaxUploadSize: number;
  fileMaxUploadSize: number;
  applicationId: string;
  clientKey: string;
  serverUrl: string;

}
